/**
 * PoliciesSection — shared component displaying cancellation, refund, and late payment policies.
 * Shows "N/A" when a policy value is null or undefined.
 * Hidden entirely when the policies object itself is null/undefined.
 */
import React from 'react';
import './styles/PoliciesSection.css';

export interface PoliciesSectionProps {
  policies?: {
    cancellationPolicy?: string | null;
    refundPolicy?: string | null;
    latePaymentPolicy?: string | null;
  } | null;
}

const displayValue = (value: string | null | undefined): string =>
  value ?? 'N/A';

export const PoliciesSection: React.FC<PoliciesSectionProps> = ({ policies }) => {
  if (!policies) return null;

  return (
    <div className="policies-section">
      <h3 className="policies-section__title">Policies</h3>
      <div className="policies-section__card">
        <div className="policies-section__row">
          <span className="policies-section__label">Cancellation</span>
          <span className="policies-section__value">{displayValue(policies.cancellationPolicy)}</span>
        </div>
        <div className="policies-section__row">
          <span className="policies-section__label">Refund</span>
          <span className="policies-section__value">{displayValue(policies.refundPolicy)}</span>
        </div>
        <div className="policies-section__row">
          <span className="policies-section__label">Late Payment</span>
          <span className="policies-section__value">{displayValue(policies.latePaymentPolicy)}</span>
        </div>
      </div>
    </div>
  );
};

export default PoliciesSection;
